export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export const LANGUAGES = [
  {
    code: "en",
    text: "EN",
  },
  {
    code: "kn",
    text: "ಕನ್ನಡ",
  },
];